import Link from "next/link";
import { IoLogoLinkedin, IoLogoTwitter } from "react-icons/io5";

export function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-gradient-to-b from-white to-slate-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12">
          <div className="space-y-4 sm:col-span-1 lg:col-span-1">
            <Link
              href="/"
              className="flex items-center text-3xl sm:text-4xl font-black bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent hover:from-indigo-700 hover:to-purple-700 transition-all"
            >
              <p>Voyas</p>
            </Link>
            <p className="text-sm sm:text-base text-gray-600 leading-relaxed max-w-sm">
              Experience effortless travel planning powered by AI, turning your
              wanderlust into expertly curated itineraries that match your
              unique style and preferences.
            </p>
            <div className="flex space-x-4 pt-2">
              <a
                href="https://www.linkedin.com/in/rickycheuk/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center w-10 h-10 rounded-lg bg-slate-100 hover:bg-indigo-100 text-gray-600 hover:text-indigo-600 transition-all duration-300"
                aria-label="LinkedIn"
              >
                <IoLogoLinkedin size={20} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-4 sm:mb-6 text-gray-900">Product</h4>
            <ul className="space-y-3">
              <li>
                <Link
                  href="/create-trip"
                  className="text-sm sm:text-base text-gray-600 hover:text-indigo-600 transition-colors"
                >
                  Trip Planner
                </Link>
              </li>
              <li>
                <Link
                  href="/pricing"
                  className="text-sm sm:text-base text-gray-600 hover:text-indigo-600 transition-colors"
                >
                  Pricing
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4 sm:mb-6 text-gray-900">Legal</h4>
            <ul className="space-y-3">
              <li>
                <Link
                  href="/privacy"
                  className="text-sm sm:text-base text-gray-600 hover:text-indigo-600 transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  href="/terms"
                  className="text-sm sm:text-base text-gray-600 hover:text-indigo-600 transition-colors"
                >
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 sm:mt-16 pt-8 border-t border-slate-200">
          <p className="text-center text-sm sm:text-base text-gray-600">
            © {new Date().getFullYear()} Voyas. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
